import { stringToIsoFormat, getHoursFromISO, getMinutesFromISO } from './date-utils';
import { storageObject } from './local-storage-utils';
export const hourArray = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
];
export const minuteArray = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
export function getInputValue(event) {
    return event.currentTarget.value;
}
const alphaNumericRegex = /^(?=.*[\d^'])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
export const isFlightFormatCorrect = (val) => !!val && alphaNumericRegex.test(val);
export function removeSpace(val) {
    return val ? val.trim() : val;
}
export function mapMTFormInputToAPISchema(mtFormData, hotelItinerary, tripId) {
    const { checkInDate, checkOutDate } = hotelItinerary;
    const { outboundFlightNumber, outboundArrivalFlightTimeHours, outboundArrivalFlightTimeMinutes, inboundFlightNumber, inboundDepartureFlightTimeHours, inboundDepartureFlightTimeMinutes, } = mtFormData;
    const outboundDate = outboundArrivalFlightTimeHours && outboundArrivalFlightTimeMinutes
        ? stringToIsoFormat(checkInDate).replace('T00:00', `T${outboundArrivalFlightTimeHours}:${outboundArrivalFlightTimeMinutes}`)
        : '';
    const inboundDate = inboundDepartureFlightTimeHours && inboundDepartureFlightTimeMinutes
        ? stringToIsoFormat(checkOutDate).replace('T00:00', `T${inboundDepartureFlightTimeHours}:${inboundDepartureFlightTimeMinutes}`)
        : '';
    return {
        tripId,
        connectingFlightData: {
            outboundFlightNumber: isFlightFormatCorrect(outboundFlightNumber) ? outboundFlightNumber : '',
            outboundDate,
            inboundFlightNumber: isFlightFormatCorrect(inboundFlightNumber) ? inboundFlightNumber : '',
            inboundDate,
        },
    };
}
export function updateMtFormState(data, setMtFormState) {
    const mtForm = {
        outboundFlightNumber: data.outboundFlightNumber || '',
        outboundArrivalFlightTimeHours: getHoursFromISO(data.outboundDate),
        outboundArrivalFlightTimeMinutes: getMinutesFromISO(data.outboundDate),
        inboundFlightNumber: data.inboundFlightNumber || '',
        inboundDepartureFlightTimeHours: getHoursFromISO(data.inboundDate),
        inboundDepartureFlightTimeMinutes: getMinutesFromISO(data.inboundDate),
    };
    return setMtFormState(mtForm);
}
export function updateMtFormValidationState(data, setMtFormValidation) {
    const mtFormValidation = {
        outboundFlightNumber: !!data.outboundFlightNumber,
        outboundArrivalFlightTimeHours: !!data.outboundDate,
        outboundArrivalFlightTimeMinutes: !!data.outboundDate,
        inboundFlightNumber: !!data.inboundFlightNumber,
        inboundDepartureFlightTimeHours: !!data.inboundDate,
        inboundDepartureFlightTimeMinutes: !!data.inboundDate,
    };
    return setMtFormValidation(mtFormValidation);
}
export const mtFormValidation = {
    transferSelect: undefined,
    outboundFlightNumber: undefined,
    inboundFlightNumber: undefined,
    hotelName: undefined,
    hotelAddress: undefined,
    departureAirportCode: undefined,
    departureAirportName: undefined,
    destinationAirportCode: undefined,
    destinationAirportName: undefined,
    inboundArrivalDate: undefined,
    outboundDepartureDate: undefined,
};
export const stripTypenames = (value) => {
    if (Array.isArray(value)) {
        return value.map(stripTypenames);
    }
    if (value !== null && typeof value === 'object') {
        const newObject = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const property in value) {
            if (property !== '__typename') {
                newObject[property] = stripTypenames(value[property]);
            }
        }
        return newObject;
    }
    return value;
};
export var StoredAirportKeys;
(function (StoredAirportKeys) {
    StoredAirportKeys["DEPARTURE"] = "storedDepartureAirport";
    StoredAirportKeys["DESTINATION"] = "storedDestinationAirport";
})(StoredAirportKeys || (StoredAirportKeys = {}));
export function useStoredAirport(localStorageName) {
    const localAirport = JSON.parse(storageObject().getItem(localStorageName) || '{ "airportCode": "", "title": ""}');
    const setAirport = (airport) => {
        storageObject().setItem(localStorageName, JSON.stringify(airport || { airportCode: '', title: '' }));
    };
    return [localAirport, setAirport];
}
export const mapAirportsToConnectingFlight = (destination, departure) => ({
    inboundDepartureAirport: (destination === null || destination === void 0 ? void 0 : destination.airportCode) || '',
    inboundDepartureAirportName: (destination === null || destination === void 0 ? void 0 : destination.title) || '',
    outboundDestinationAirport: (destination === null || destination === void 0 ? void 0 : destination.airportCode) || '',
    outboundDestinationAirportName: (destination === null || destination === void 0 ? void 0 : destination.title) || '',
    inboundDestinationAirport: (departure === null || departure === void 0 ? void 0 : departure.airportCode) || '',
    inboundDestinationAirportName: (departure === null || departure === void 0 ? void 0 : departure.title) || '',
    outboundDepartureAirport: (departure === null || departure === void 0 ? void 0 : departure.airportCode) || '',
    outboundDepartureAirportName: (departure === null || departure === void 0 ? void 0 : departure.title) || '',
});
export const areFlightDetailsComplete = (connFlight) => {
    if (!connFlight)
        return false;
    const { connectingFlightData } = connFlight;
    const values = Object.values(connectingFlightData);
    return Object.keys(connectingFlightData).every((x, i) => { var _a; return x.includes('FlightNumber') ? isFlightFormatCorrect((_a = values[i]) !== null && _a !== void 0 ? _a : '') : values[i] !== ''; });
};
